import { Outlet } from "react-router";
import { GlobalHeader } from "@lending/components/GlobalHeader/GlobalHeader";
import styles from "./MainLayout.module.css";

interface MainLayoutProps {
  flowType: "web" | "olb";
}

function MainLayout({ flowType }: MainLayoutProps) {
  return (
    <div className={styles.appContainer}>
      <GlobalHeader flowType={flowType} />
      <main className={styles.mainContent}>
        <Outlet />
      </main>
    </div>
  );
}

export { MainLayout };
